import { gql } from "@apollo/client";
import {
  ViewingRoom,
  WarehouseLocation,
  WarehouseLocationType,
  WarehouseSite,
} from "../fragments";

const UPDATE_WAREHOUSE_SITE = gql`
  mutation UpdateWarehouseSite($input: UpdateWarehouseSiteInput!) {
    updateWarehouseSite(input: $input) {
      success
      error
      warehouseSite {
        ${WarehouseSite}
      }
    }
  }
`;

const CREATE_WAREHOUSE_LOCATION = gql`
  mutation CreateWarehouseLocation($input: CreateWarehouseLocationInput!) {
    createWarehouseLocation(input: $input) {
      success
      error
      warehouseLocation {
        ${WarehouseLocation()}
      }
    }
  }
`;

const UPDATE_WAREHOUSE_LOCATION = gql`
  mutation UpdateWarehouseLocation($input: UpdateWarehouseLocationInput!) {
    updateWarehouseLocation(input: $input) {
      success
      error
      warehouseLocation {
        ${WarehouseLocation({ type: true, viewingRoom: true })}
      }
    }
  }
`;

const ASSIGN_VIEWING_ROOMS_TO_SITE = gql`
  mutation AssignViewingRoomsToSite($input: AssignViewingRoomsToSiteInput!) {
    assignViewingRoomsToSite(input: $input) {
      count
      success
      error
      viewingRooms {
        ${ViewingRoom}
      }
    }
  }
`;

const CREATE_VIEWING_ROOM = gql`
  mutation CreateViewingRoom($input: CreateViewingRoomInput!) {
    createViewingRoom(input: $input) {
      success
      error
      viewingRoom {
        ${ViewingRoom}
      }
    }
  }
`;

const DELETE_VIEWING_ROOM = gql`
  mutation DeleteViewingRoom($input: DeleteViewingRoomInput!) {
    deleteViewingRoom(input: $input) {
      success
      error
    }
  }
`;

const UPDATE_VIEWING_ROOM = gql`
  mutation UpdateViewingRoom($input: UpdateViewingRoomInput!) {
    updateViewingRoom(input: $input) {
      success
      error
      viewingRoom {
        ${ViewingRoom}
      }
    }
  }
`;

const CREATE_WAREHOUSE_LOCATION_TYPE = gql`
  mutation CreateWarehouseLocationType($input: CreateWarehouseLocationTypeInput!) {
    createWarehouseLocationType(input: $input) {
      success
      error
      warehouseLocationType {
        ${WarehouseLocationType}
      }
    }
  }
`;

const DELETE_WAREHOUSE_LOCATION_TYPE = gql`
  mutation DeleteWarehouseLocationType($input: DeleteWarehouseLocationTypeInput!) {
    deleteWarehouseLocationType(input: $input) {
      success
      error
    }
  }
`;

const UPDATE_WAREHOUSE_LOCATION_TYPE = gql`
  mutation UpdateWarehouseLocationType($input: UpdateWarehouseLocationTypeInput!) {
    updateWarehouseLocationType(input: $input) {
      success
      error
      warehouseLocationType {
        ${WarehouseLocationType}
      }
    }
  }
`;

export {
  ASSIGN_VIEWING_ROOMS_TO_SITE,
  CREATE_VIEWING_ROOM,
  CREATE_WAREHOUSE_LOCATION,
  CREATE_WAREHOUSE_LOCATION_TYPE,
  DELETE_VIEWING_ROOM,
  DELETE_WAREHOUSE_LOCATION_TYPE,
  UPDATE_VIEWING_ROOM,
  UPDATE_WAREHOUSE_LOCATION,
  UPDATE_WAREHOUSE_LOCATION_TYPE,
  UPDATE_WAREHOUSE_SITE,
};
